/** Dossier virtuel client — file d’envoi locale (pas IMAP). */
export const AURELIA_OUTBOX_FOLDER = "__aurelia_outbox__";

/** Libellé en attente dans la file (avant envoi SMTP actif). */
export const OUTBOX_FOLDER_LABEL = "En attente d'envoi";

export const SENDING_FOLDER_LABEL = "Envoi en cours";

/** Pendant le POST de programmation (placeholder), pas l’envoi SMTP. */
export const SCHEDULING_FOLDER_LABEL = "Enregistrement en cours";

export const SCHEDULED_OUTBOX_LABEL = "Envois programmés";

/** @deprecated Alias historique — même vue que {@see AURELIA_OUTBOX_FOLDER}. */
export const AURELIA_SENDING_FOLDER = "__aurelia_sending__";

export function isOutboxNavFolder(name: string): boolean {
  return name === AURELIA_OUTBOX_FOLDER || name === AURELIA_SENDING_FOLDER;
}
